import React from "react";
import styled from 'styled-components';

import Chartable from "../../interfaces/Chartable";
import Scalable from '../../interfaces/Scalable';
import {useTranslation} from "react-i18next";


interface HorizontalAxisProps extends Scalable, Chartable {
  ticks: number[],
  formatTicks?: (n: number) => string,
}

const HorizontalLabel = styled.text`
  fill: #FBFBFB;
  font-size: 0.8rem;
`;

const HorizontalAxis: React.FC<HorizontalAxisProps> = (props: HorizontalAxisProps) => {

  const { i18n } = useTranslation();
  const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || 'es';
  const defaultFormatTicker = (tick: number): string => (
    new Intl.NumberFormat(getCurrentLng() === 'es' ? 'de' : getCurrentLng()).format(tick)
  );
  const formatTick = props.formatTicks || defaultFormatTicker;

  return (
    <g className='horizontal-axis'>
      { props.ticks.map(tick => {
          const x = props.xScale(tick);
          const y = props.dimensions.height + props.margins.bottom;

          return (
            <HorizontalLabel
                x={ x }
                y={ y }
                transform={`rotate(-90,${x},${y})`}
                key={ `horizontal-tick-${tick}` }
              >
              { formatTick(tick) }
            </HorizontalLabel>
          );
        })
      }
    </g>
  )
};

export default HorizontalAxis;
